<template>
  <div class="p-md-2 px-3">
    <form @submit.prevent="add(message)">
      <div class="form-group mt-md-0 mt-3">
        <small class="text-pink">at least 3 characters</small>
        <input v-model="message.name" type="text" name="name" class="form-control border text-white bg-dark"
          placeholder="n a m e" v-focus /><i class="material-icons text-pink mr-2"
          style="float: right;position: relative;top:-28px;">person</i>
      </div>

      <small class="text-pink">at least 11 characters</small>
      <div class="form-group">
        <input v-model="message.phone" type="number" name="phone" class="form-control bg-dark   text-white"
          placeholder="p h o n e" />
        <i class="material-icons text-pink mr-2 pointer" style="float: right;position: relative;top:-28px;">phone</i>
      </div>

      <small class="text-pink">at least 1 characters</small>
      <div class="form-group">
        <textarea v-on:keyup="inputVilidation(message)" v-on:mouseleave="inputVilidation(message)" v-model="message.msg"
          rows="3" name="text" class="form-control bg-dark  text-white" placeholder="message"></textarea>
      </div>

      <input id="mouseMoveAni" data-value="5" :disabled="is_disabled_submit_btn"
        class="contact-send mt-md-3 mt-2 btn pl-4 pr-4  btn-sm text-dark custom-bg-color" type="submit" for="customFile"
        value="Send" />
    </form>

  </div>
</template>
<script>

export default {
  name: 'ContactForm',
  data: function () {
    return {
      is_disabled_submit_btn: true,
      message: {
        name: "",
        phone: "",
        msg: ""
      }
    };
  },

  methods: {

    inputVilidation(messageObj) {
      messageObj.name.length > 2 &&

        messageObj.msg.length >= 1 ?
        this.is_disabled_submit_btn = false :
        this.is_disabled_submit_btn = true;
    },

    add(event) {

      event.name.length > 2 &&
        event.msg.length >= 1 ?
        this.$emit("input", this.message) :
        alert('Please fill all input field !');

      this.message.name = '',
        this.message.phone = '',
        this.message.msg = ''

    }
  },
};
</script>
<style>
.custom-bg-color {
  background-color: #ec4e10;
}
</style>











